export default __webpack_public_path__ + "static/media/boa.58301784.png";